import select from 'dominus';

let menuIsOpen = false;

const _body = select('body');
let _menuToggle;

function toggleMobileMenu (e) {
    e.preventDefault();

    let menuText = _menuToggle.find('#mobile-menu-text');

    if (menuIsOpen) {
        // menu is open so close it
        menuText.text('Menu');
        _body.removeClass('mobile-menu--visible').addClass('mobile-menu--hidden');
        menuIsOpen = false;

    } else {
        menuText.text('Close');
        _body.removeClass('mobile-menu--hidden').addClass('mobile-menu--visible');
        menuIsOpen = true;
    }
}

export function init(config) {
    _menuToggle = select(config.mobileMenuTrigger).on('click', toggleMobileMenu);
}

export default { init: init }
